import { Controller } from "@hotwired/stimulus"
import TomSelect from 'tom-select'
import 'tom-select/dist/esm/plugins/remove_button/plugin'

export default class extends Controller {
    static targets = ["input"]
    static values = {
        colors: Object,
        maxDisplayed: { type: Number, default: 3 }
    }

    connect() {
        this.initializeMultiplePoolsTomSelect();
    }

    disconnect() {
        if (this.tomselect) {
            this.tomselect.destroy();
        }
    }

    initializeMultiplePoolsTomSelect() {
        // Konvertiere HTML-Optionen zu TomSelect-Format
        const options = Array.from(this.inputTarget.options).map(option => ({
            id: option.value,
            text: option.text
        }));

        this.tomselect = new TomSelect(this.inputTarget, {
            valueField: 'id',
            labelField: 'text',
            searchField: 'text',
            multiple: true,
            maxItems: null, // Keine Begrenzung der Anzahl auswählbarer Items
            allowEmptyOption: true,
            placeholder: this.inputTarget.getAttribute('placeholder') || "Bitte auswählen",
            options: options,
            plugins: {
                'remove_button': {
                    title: 'Pool entfernen'
                }
            },
            render: {
                option: (data, escape) => {
                    if (!data.id) {
                        return `<div class="flex items-center p-2">
                            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium bg-white">
                                ${escape(data.text)}
                            </span>
                        </div>`;
                    }
                    const color = this.colorsValue[data.id] || '#E5E7EB';
                    return `<div class="flex items-center p-2">
                        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium" 
                              style="background-color: ${color}">
                            ${escape(data.text)}
                        </span>
                    </div>`;
                },
                item: (data, escape) => {
                    if (!data.id) {
                        return `<div class="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium bg-white">
                            ${escape(data.text)}
                        </div>`;
                    }
                    const color = this.colorsValue[data.id] || '#E5E7EB';
                    return `<div class="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium" 
                              style="background-color: ${color}">
                        ${escape(data.text)}
                    </div>`;
                },
                // Custom render function für die Anzeige der ausgewählten Items
                items: (data, escape) => {
                    if (data.length === 0) {
                        return '';
                    }

                    const items = data.map(item => {
                        if (!item.id) {
                            return `<span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium bg-white">
                                ${escape(item.text)}
                            </span>`;
                        }
                        const color = this.colorsValue[item.id] || '#E5E7EB';
                        return `<span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium" 
                                   style="background-color: ${color}">
                            ${escape(item.text)}
                        </span>`;
                    });

                    // Zeige nur die ersten maxDisplayed Items an, der Rest wird mit "+X" angezeigt
                    if (items.length <= this.maxDisplayedValue) {
                        return `<div class="flex gap-1">${items.join('')}</div>`;
                    } else {
                        const displayedItems = items.slice(0, this.maxDisplayedValue);
                        const remainingCount = items.length - this.maxDisplayedValue;
                        return `<div class="flex gap-1">${displayedItems.join('')}<span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium bg-gray-200 text-gray-700 truncate">
                                    +${remainingCount}
                                </span></div>`;
                    }
                }
            }
        });
    }

    updateDisplay() {
        // Force re-render der Items
        if (this.tomselect) {
            this.tomselect.refreshItems();
        }
    }
} 